import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgCW20Transfer extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgCW20Transfer(params);
    }
    toData() {
        const { params } = this;
        return {
            recipient: params.recipient,
            amount: params.amount,
        };
    }
    toExecData() {
        return dataToExecData('transfer', this.toData());
    }
}
